// extracted by mini-css-extract-plugin
module.exports = {"volumeSlider":"VolumeSlider_volumeSlider__3CIXg","track":"VolumeSlider_track__2AXt7","thumb":"VolumeSlider_thumb__3qvGW"};